"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CHARACTERS = [
    ['&', '&amp'],
    ['<', '&lt'],
    ['>', '&gt'],
    ['"', '&quot'],
    ["'", '&#x27'],
    ['/', '&#x2F']
];
/**
 * HTML encoder.
 */
var HtmlEncoder = /** @class */ (function () {
    function HtmlEncoder() {
    }
    /**
     * Encode for attribute.
     *
     * @param text Model object.
     * @returns Encoded text.
     */
    HtmlEncoder.encodeForAttribute = function (text) {
        for (var _i = 0, CHARACTERS_1 = CHARACTERS; _i < CHARACTERS_1.length; _i++) {
            var character = CHARACTERS_1[_i];
            text = text.replace(new RegExp(character[0], 'gm'), character[1] + ';');
        }
        return text;
    };
    return HtmlEncoder;
}());
exports.default = HtmlEncoder;
//# sourceMappingURL=HtmlEncoder.js.map